module.exports = __webpack_public_path__ + "static/img/Advantage_comparison@2x.cd34fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/MYBANK/Advantage_comparison@2x.png
// module id = ZSud
// module chunks = 70